export default __webpack_public_path__ + "img/91d03a659257ccd065318c481d35fba8.svg";